import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from '../../services/session'
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            id: 0,
            displayName: '',
            name: '',
            title: ''
        }
    },
    methods: {
        add: add,
        edit: edit,
    },
    beforeMount() {
        if(session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        let _self = this;
        this.id = this.$route.query.id;
        this.displayName = this.$route.query.name;
        if(this.id == null){
            this.title = LocService.t('label_partner_add_title')
        }else{
            this.title = LocService.t('label_partner_edit_title')
        }
    }
}

function add(){
    if(this.name == null || this.name.length === 0){
        swal(LocService.t('label_error'), LocService.t('label_partner_all_field_required'), 'error');
        return;
    }
    if(this.id != null){
        this.edit()
        return;
    }
    let newModel = {
        name : this.name
    }
    AdminApiService.addCompanyPayments(newModel)
        .then((response) => {
            this.$router.push('/company-payment');
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function edit(){
    let newModel = {
        id: this.id,
        name : this.name
    }
    AdminApiService.updateCompanyPayments(newModel)
        .then((response) => {
            this.$router.push('/company-payment');
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/CompanyPayment/AddEditCompanyPayment.js